import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import {
  StockLocationType,
  StockLocationTypeLabel,
} from "features/StockLocations/constants/stock-location.constants";

export type StockLocationListFiltersProps = {
  typeFilter: StockLocationType | "";
  onTypeChange: (value: StockLocationType | "") => void;
};

export default function StockLocationListFilters({
  typeFilter,
  onTypeChange,
}: StockLocationListFiltersProps) {
  return (
    <Row className="g-2 g-md-3 align-items-end flex-grow-1 w-100 mb-0">
      <Col xs={12} sm={6} md={4} lg={3}>
        <Label className="form-label text-muted small mb-1">Type</Label>
        <Input
          type="select"
          className="form-select"
          value={typeFilter}
          onChange={(e) =>
            onTypeChange((e.target.value || "") as StockLocationType | "")
          }
        >
          <option value="">All types</option>
          {(Object.values(StockLocationType) as StockLocationType[]).map(
            (t) => (
              <option key={t} value={t}>
                {StockLocationTypeLabel[t]}
              </option>
            ),
          )}
        </Input>
      </Col>
    </Row>
  );
}
